module.exports = __webpack_public_path__ + "static/pink-circle-3effe5c40b9a7144a2590e3d93dd6028.png";